export default "__VITE_ASSET__BaDa4mwb__"